import { ɵɵdefineInjectable, Injectable, Component, Input, EventEmitter, ComponentFactoryResolver, ViewChild, ViewContainerRef, ElementRef, Renderer2, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditorContextHelper, LoggerService, PageEditorBridge, PersonalizationService, TemplateAnnotations } from '@magnolia/template-annotations';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

function DefaultFallbackComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const prop_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2(" ", prop_r1.key, ": ", ctx_r0.formatValue(prop_r1.value), " ");
} }
const _c0 = ["editable-area", ""];
function EditableArea_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "mgnl-comment", 3);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("text", ctx_r0.openComment);
} }
function EditableArea_2_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "editable-component", 5);
} if (rf & 2) {
    const component_r5 = ctx.$implicit;
    const i_r6 = ctx.index;
    ɵngcc0.ɵɵproperty("content", component_r5)("index", i_r6);
} }
function EditableArea_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, EditableArea_2_ng_template_0_Template, 1, 2, "ng-template", 4);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.components);
} }
function EditableArea_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function EditableArea_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "mgnl-comment", 3);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("text", ctx_r3.closeComment);
} }
const _c1 = ["*"];
const _c2 = ["child"];
function EditableComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "mgnl-comment", 2);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("text", ctx_r0.openComment);
} }
function EditableComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "mgnl-comment", 2);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("text", ctx_r2.closeComment);
} }
function _window() {
    return window;
}
class WindowRefService {
    // Return the native Javascript window object
    get nativeWindow() {
        return _window();
    }
}
WindowRefService.ɵfac = function WindowRefService_Factory(t) { return new (t || WindowRefService)(); };
WindowRefService.ɵprov = ɵɵdefineInjectable({ factory: function WindowRefService_Factory() { return new WindowRefService(); }, token: WindowRefService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(WindowRefService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

const TEMPLATE_ID_PROP = 'mgnl:template';
var constants = {
    TEMPLATE_ID_PROP
};

class DefaultFallbackComponent {
    get templateId() {
        return this.metadata[TEMPLATE_ID_PROP];
    }
    trimIfObject(value) {
        if (value === '[object Object]') {
            return '[object]';
        }
        return value;
    }
    formatValue(value) {
        return this.trimIfObject('' + value);
    }
}
DefaultFallbackComponent.ɵfac = function DefaultFallbackComponent_Factory(t) { return new (t || DefaultFallbackComponent)(); };
DefaultFallbackComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DefaultFallbackComponent, selectors: [["ng-component"]], inputs: { metadata: "metadata", data: "data" }, decls: 8, vars: 4, consts: [[4, "ngFor", "ngForOf"]], template: function DefaultFallbackComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div")(1, "div")(2, "strong")(3, "em");
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵtemplate(5, DefaultFallbackComponent_div_5_Template, 2, 2, "div", 0);
        ɵngcc0.ɵɵpipe(6, "keyvalue");
        ɵngcc0.ɵɵelement(7, "p");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1("Template not found: ", ctx.templateId, "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind1(6, 2, ctx.data));
    } }, dependencies: [ɵngcc1.NgForOf, ɵngcc1.KeyValuePipe], encapsulation: 2 });
DefaultFallbackComponent.propDecorators = {
    metadata: [{ type: Input }],
    data: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DefaultFallbackComponent, [{
        type: Component,
        args: [{
                template: `
    <div>
      <div>
        <strong>
          <em>Template not found: {{ templateId }}</em>
        </strong>
      </div>
      <div *ngFor="let prop of data | keyvalue">
        {{ prop.key }}: {{ formatValue(prop.value) }}
      </div>
      <p></p>
    </div>
  `
            }]
    }], null, { metadata: [{
            type: Input
        }], data: [{
            type: Input
        }] }); })();

class EditorContextService {
    constructor() {
        /** Change-detection for asynchronous fetching of template annotations */
        this.templateAnnotationsUpdated = new EventEmitter();
        /** Change-detection for asynchronous fetching of template definitions */
        this.templateDefinitionsUpdated = new EventEmitter();
        /** Component mapping */
        this.componentMapping = {};
        /** Template definitions */
        this.templateDefinitions = null;
        /** Template annotations */
        this.templateAnnotations = null;
    }
    setServerUrl(url) {
        EditorContextHelper.setServerUrl(url);
    }
    inIframe() {
        return EditorContextHelper.inIframe();
    }
    inEditor() {
        return EditorContextHelper.inEditor();
    }
    /** @deprecated Since version 1.2.0. Use inIframe with params check instead. */
    inEditorAsync() {
        return EditorContextHelper.inEditorAsync();
    }
    refresh(delayInMilliseconds) {
        EditorContextHelper.refresh(delayInMilliseconds);
    }
    inEditorPreview() {
        return EditorContextHelper.inEditorPreview();
    }
    isPageEditorReady() {
        return EditorContextHelper.isPageEditorReady();
    }
    onFrameReady() {
        EditorContextHelper.onFrameReady();
    }
    // tslint:disable-next-line:max-line-length
    getMagnoliaContext(requestUrl, spaRootNodePath, languages) {
        return EditorContextHelper.getMagnoliaContext(requestUrl, spaRootNodePath, languages);
    }
    setComponentMapping(componentMapping) {
        if (!componentMapping) {
            LoggerService.error('componentMapping cannot be null');
            return;
        }
        this.componentMapping = componentMapping;
    }
    // tslint:disable-next-line:ban-types
    setFallbackComponent(customFallbackComponent) {
        this.fallbackComponent = customFallbackComponent;
    }
    getFallbackComponent() {
        const fallback = typeof this.fallbackComponent === 'function' ? this.fallbackComponent() : this.fallbackComponent;
        return typeof fallback === 'function' ? fallback : fallback ? DefaultFallbackComponent : null;
    }
    getComponentMapping(templateId) {
        if (!templateId) {
            const msg = 'Component content is missing';
            LoggerService.error(msg);
            return null;
        }
        if (!this.componentMapping) {
            const msg = 'Component mappings is missing';
            LoggerService.error(msg);
            return null;
        }
        const component = this.componentMapping[templateId];
        if (!component) {
            LoggerService.error(`Component with ID ${templateId} is not mapped.`);
            const fallbackComponent = this.getFallbackComponent();
            if (fallbackComponent) {
                fallbackComponent.isFallbackComponent = true;
            }
            return fallbackComponent;
        }
        return component;
    }
    getComponentProperties(componentContent, index, isFallbackComponent) {
        if (!componentContent || typeof componentContent !== 'object') {
            return {};
        }
        const props = {};
        let propsContainer;
        if (isFallbackComponent) {
            props.data = {};
            propsContainer = props.data;
        }
        else {
            propsContainer = props;
        }
        props.metadata = { '@index': index };
        props.key = componentContent['@id'];
        Object.keys(componentContent).forEach(key => {
            if (key.match(/^(@|mgnl:|jcr:)/)) {
                props.metadata[key] = componentContent[key];
            }
            else {
                propsContainer[key.replace('-', '_')] = componentContent[key];
            }
        });
        return props;
    }
    setComponentProperties(componentRefInstance, props) {
        Object.entries(props).map(([key, value]) => {
            // @ts-ignore
            componentRefInstance[key] = value;
        });
    }
    /** @deprecated Since version 1.3. Use template-annotations endpoint instead. */
    setTemplateDefinitions(templateDefinitions) {
        LoggerService.warn('Template-definitions endpoint is deprecated. Please migrate your code to use template-annotations endpoint instead.');
        this.templateDefinitions = templateDefinitions;
        this.templateDefinitionsUpdated.emit(this.templateDefinitions);
    }
    getTemplateDefinition(template) {
        return this.templateDefinitions[template];
    }
    setTemplateAnnotations(templateAnnotations) {
        this.templateAnnotations = templateAnnotations;
        this.templateAnnotationsUpdated.emit(this.templateAnnotations);
    }
    getTemplateAnnotation(path) {
        return this.templateAnnotations[path];
    }
    getTemplateAnnotations() {
        return this.templateAnnotations;
    }
    isRenderingAnnotation() {
        return EditorContextHelper.isRenderingAnnotation();
    }
    // tslint:disable-next-line:ban-types
    initPageEditorBridge(callback) {
        PageEditorBridge.init(callback);
    }
    // tslint:disable-next-line:ban-types
    registerOnMessageEvent(action, callback) {
        PageEditorBridge.onMessage(action, callback);
    }
}
EditorContextService.ɵfac = function EditorContextService_Factory(t) { return new (t || EditorContextService)(); };
EditorContextService.ɵprov = ɵɵdefineInjectable({ factory: function EditorContextService_Factory() { return new EditorContextService(); }, token: EditorContextService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorContextService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

/**
 * @deprecated RendererContextService is deprecated. Use EditorContextService instead.
 */
class RendererContextService extends EditorContextService {
    constructor() {
        super();
        console.warn('RendererContextService is deprecated. Use EditorContextService instead.');
    }
}
RendererContextService.ɵfac = function RendererContextService_Factory(t) { return new (t || RendererContextService)(); };
RendererContextService.ɵprov = ɵɵdefineInjectable({ factory: function RendererContextService_Factory() { return new RendererContextService(); }, token: RendererContextService, providedIn: "root" });
RendererContextService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RendererContextService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class PersonalizationServiceHelper {
    constructor() {
        this.selectedComponentVariantsUpdated = new EventEmitter();
        this.selectedComponentVariants = null;
    }
    getVariant(content, templateAnnotations) {
        return PersonalizationService.getVariant(content, templateAnnotations);
    }
    wrap(templateAnnotations, selectedComponentVariants) {
        return PersonalizationService.wrap(templateAnnotations, selectedComponentVariants);
    }
    setSelectedComponentVariants(selectedComponentVariants) {
        this.selectedComponentVariants = selectedComponentVariants;
        this.selectedComponentVariantsUpdated.emit(this.selectedComponentVariants);
    }
    getSelectedComponentVariants() {
        return this.selectedComponentVariants;
    }
}
PersonalizationServiceHelper.ɵfac = function PersonalizationServiceHelper_Factory(t) { return new (t || PersonalizationServiceHelper)(); };
PersonalizationServiceHelper.ɵprov = ɵɵdefineInjectable({ factory: function PersonalizationServiceHelper_Factory() { return new PersonalizationServiceHelper(); }, token: PersonalizationServiceHelper, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PersonalizationServiceHelper, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class EditableArea {
    constructor(editorContext) {
        this.editorContext = editorContext;
        this.components = [];
    }
    ngOnInit() {
        this.templateAnnotationSubscription = this.editorContext.templateAnnotationsUpdated.subscribe(() => this.updateComment(this.content));
        this.templateDefinitionSubscription = this.editorContext.templateDefinitionsUpdated.subscribe(() => this.updateComment(this.content));
    }
    ngAfterViewInit() {
        this.updateComment(this.content);
    }
    ngOnDestroy() {
        var _a, _b;
        (_a = this.templateAnnotationSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        (_b = this.templateDefinitionSubscription) === null || _b === void 0 ? void 0 : _b.unsubscribe();
    }
    getAreaComponents(content) {
        const results = [];
        if (content) {
            const components = content['@nodes'];
            components.forEach(nodeName => {
                const value = content[nodeName];
                if (typeof (value) === 'object' && value['@nodeType'] === 'mgnl:component') {
                    results.push(value);
                }
            });
            const metadata = {};
            Object.keys(content).forEach(key => {
                if (key.startsWith('@') || key.startsWith('mgnl:') || key.startsWith('jcr:')) {
                    metadata[key] = content[key];
                }
                else {
                    this[key.replace('-', '_')] = content[key];
                }
            });
            this.metadata = metadata;
        }
        return results;
    }
    ngOnChanges(changes) {
        if (changes.content) {
            this.components = this.getAreaComponents(changes.content.currentValue);
            this.areaContext = { $implicit: changes.content.currentValue, components: this.components };
        }
    }
    updateComment(content) {
        this.editorContext.inEditorAsync().then((inEditor) => {
            if (!inEditor) {
                return;
            }
            if (!content) {
                LoggerService.warn('No content for this area');
                return;
            }
            if (this.editorContext.templateAnnotations && this.editorContext.templateAnnotations[content['@path']]) {
                this.openComment = this.editorContext.templateAnnotations[content['@path']];
                this.closeComment = '/cms:area';
            }
            else if (this.editorContext.templateDefinitions && this.editorContext.templateDefinitions[this.parentTemplateId]) {
                // tslint:disable-next-line:max-line-length
                this.openComment = TemplateAnnotations.getAreaCommentString(content, this.editorContext.templateDefinitions[this.parentTemplateId]);
                this.closeComment = '/cms:area';
            }
            this.editorContext.refresh();
        });
    }
}
EditableArea.ɵfac = function EditableArea_Factory(t) { return new (t || EditableArea)(ɵngcc0.ɵɵdirectiveInject(EditorContextService)); };
EditableArea.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: EditableArea, selectors: [["", "editable-area", ""]], inputs: { parentTemplateId: "parentTemplateId", content: "content", customView: "customView" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], attrs: _c0, ngContentSelectors: _c1, decls: 5, vars: 5, consts: [[3, "ngIf"], [4, "ngIf"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "text"], ["ngFor", "", 3, "ngForOf"], [3, "content", "index"]], template: function EditableArea_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, EditableArea_ng_template_0_Template, 1, 1, "ng-template", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵtemplate(2, EditableArea_2_Template, 1, 1, null, 1);
        ɵngcc0.ɵɵtemplate(3, EditableArea_ng_container_3_Template, 1, 0, "ng-container", 2);
        ɵngcc0.ɵɵtemplate(4, EditableArea_ng_template_4_Template, 1, 1, "ng-template", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.openComment);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.customView);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.customView)("ngTemplateOutletContext", ctx.areaContext);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.closeComment);
    } }, dependencies: function () { return [ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, EditableComponent, CommentComponent]; }, encapsulation: 2 });
EditableArea.ctorParameters = () => [
    { type: EditorContextService }
];
EditableArea.propDecorators = {
    parentTemplateId: [{ type: Input }],
    content: [{ type: Input }],
    customView: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditableArea, [{
        type: Component,
        args: [{
                selector: '[editable-area]',
                template: `
    <ng-template [ngIf]="openComment">
      <mgnl-comment [text]="openComment"></mgnl-comment>
    </ng-template>
    <ng-content></ng-content>
    <ng-template *ngIf="!customView" ngFor let-component [ngForOf]="components" let-i="index">
        <editable-component [content]="component" [index]="i"></editable-component>
    </ng-template>
    <ng-container *ngTemplateOutlet="customView; context: areaContext">
    </ng-container>
    <ng-template [ngIf]="closeComment">
      <mgnl-comment [text]="closeComment"></mgnl-comment>
    </ng-template>
  `
            }]
    }], function () { return [{ type: EditorContextService }]; }, { parentTemplateId: [{
            type: Input
        }], content: [{
            type: Input
        }], customView: [{
            type: Input
        }] }); })();

class AbstractComponent {
    constructor(resolver, editorContext, personalizationService) {
        this.resolver = resolver;
        this.editorContext = editorContext;
        this.personalizationService = personalizationService;
        this.index = 0;
    }
    ngOnChanges(changes) {
        this.reloadComponent(changes.content.currentValue);
    }
    ngOnInit() {
        // re-render when either template annotations or selected component variants change
        this.templateAnnotationSubscription = this.editorContext.templateAnnotationsUpdated.subscribe(() => this.reloadComponent(this.content));
        this.templateDefinitionSubscription = this.editorContext.templateDefinitionsUpdated.subscribe(() => this.reloadComponent(this.content));
        // tslint:disable-next-line:max-line-length
        this.selectedComponentVariantsSubscription = this.personalizationService.selectedComponentVariantsUpdated.subscribe(() => this.reloadComponent(this.content));
    }
    ngOnDestroy() {
        var _a, _b, _c;
        (_a = this.templateAnnotationSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        (_b = this.templateDefinitionSubscription) === null || _b === void 0 ? void 0 : _b.unsubscribe();
        (_c = this.selectedComponentVariantsSubscription) === null || _c === void 0 ? void 0 : _c.unsubscribe();
    }
    reloadComponent(content) {
        if (!content) {
            return;
        }
        // Get personalized content
        const selectedVariants = this.personalizationService.selectedComponentVariants;
        let renderingAnnotations = this.editorContext.getTemplateAnnotations();
        if (renderingAnnotations) {
            renderingAnnotations = this.personalizationService.wrap(this.editorContext.templateAnnotations, selectedVariants);
        }
        const variantContent = renderingAnnotations ? this.personalizationService.getVariant(content, renderingAnnotations) : content;
        const renderingContent = TemplateAnnotations.generateMissingAreas(variantContent, renderingAnnotations);
        // Get the component class from mapping and create the instance
        const componentClass = this.editorContext.getComponentMapping(renderingContent['mgnl:template']);
        if (componentClass) {
            setTimeout(() => this.loadComponent(componentClass, this.child, renderingContent));
        }
    }
    loadComponent(componentClass, viewContainerRef, content) {
        // Get the component factory
        const componentFactory = this.resolver.resolveComponentFactory(componentClass);
        // Get the view container and set content
        viewContainerRef.clear();
        const componentRefInstance = viewContainerRef.createComponent(componentFactory).instance;
        const props = this.editorContext.getComponentProperties(content, this.index, componentClass.isFallbackComponent);
        this.editorContext.setComponentProperties(componentRefInstance, props);
    }
}
AbstractComponent.ɵfac = function AbstractComponent_Factory(t) { return new (t || AbstractComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(EditorContextService), ɵngcc0.ɵɵdirectiveInject(PersonalizationServiceHelper)); };
AbstractComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AbstractComponent, selectors: [["ng-component"]], viewQuery: function AbstractComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c2, 5, ViewContainerRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.child = _t.first);
    } }, inputs: { index: "index", content: "content" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 0, vars: 0, template: function AbstractComponent_Template(rf, ctx) { }, encapsulation: 2 });
AbstractComponent.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: EditorContextService },
    { type: PersonalizationServiceHelper }
];
AbstractComponent.propDecorators = {
    child: [{ type: ViewChild, args: ['child', { static: false, read: ViewContainerRef },] }],
    index: [{ type: Input }],
    content: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AbstractComponent, [{
        type: Component,
        args: [{
                template: ''
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: EditorContextService }, { type: PersonalizationServiceHelper }]; }, { index: [{
            type: Input
        }], child: [{
            type: ViewChild,
            args: ['child', { static: false, read: ViewContainerRef }]
        }], content: [{
            type: Input
        }] }); })();

class CommentComponent {
    constructor(elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
    }
    set text(text) {
        if (text && this.elementRef.nativeElement.parentElement) {
            this.renderer.setProperty(this.elementRef.nativeElement, 'outerHTML', `<!-- ${text} -->`);
        }
    }
    setInner(text) {
        if (text && this.elementRef.nativeElement.parentElement) {
            this.renderer.setProperty(this.elementRef.nativeElement, 'innerHTML', `<!-- ${text} -->`);
        }
    }
}
CommentComponent.ɵfac = function CommentComponent_Factory(t) { return new (t || CommentComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
CommentComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CommentComponent, selectors: [["mgnl-comment"]], inputs: { text: "text" }, decls: 0, vars: 0, template: function CommentComponent_Template(rf, ctx) { }, encapsulation: 2 });
CommentComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
CommentComponent.propDecorators = {
    text: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CommentComponent, [{
        type: Component,
        args: [{
                selector: 'mgnl-comment',
                template: ''
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { text: [{
            type: Input
        }] }); })();

class EditablePage extends AbstractComponent {
    constructor(resolver, editorContext, personalizationService) {
        super(resolver, editorContext, personalizationService);
        this.resolver = resolver;
        this.editorContext = editorContext;
        this.personalizationService = personalizationService;
    }
    ngOnChanges(changes) {
        super.ngOnChanges(changes);
        if (changes.content) {
            this.updateComment(changes.content.currentValue);
        }
    }
    ngOnInit() {
        super.ngOnInit();
        this.templateAnnotationSubscription = this.editorContext.templateAnnotationsUpdated.subscribe(() => this.updateComment(this.content));
        this.templateDefinitionSubscription = this.editorContext.templateDefinitionsUpdated.subscribe(() => this.updateComment(this.content));
    }
    ngAfterViewInit() {
        this.editorContext.initPageEditorBridge();
        this.editorContext.registerOnMessageEvent('updateState', (message) => {
            this.personalizationService.setSelectedComponentVariants(message.selectedComponentVariants);
        });
        this.updateComment(this.content);
    }
    ngOnDestroy() {
        var _a, _b;
        super.ngOnDestroy();
        (_a = this.templateAnnotationSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        (_b = this.templateDefinitionSubscription) === null || _b === void 0 ? void 0 : _b.unsubscribe();
    }
    updateComment(content) {
        if (!content || !this.editorContext.inIframe()) {
            return;
        }
        if (this.editorContext.templateAnnotations && this.editorContext.templateAnnotations[content['@path']]) {
            const openComment = this.editorContext.templateAnnotations[content['@path']];
            this.commentComponent.setInner(openComment);
        }
        else if (this.editorContext.templateDefinitions && this.editorContext.templateDefinitions[content['mgnl:template']]) {
            // tslint:disable-next-line:max-line-length
            const openComment = TemplateAnnotations.getPageCommentString(content, this.editorContext.templateDefinitions[content['mgnl:template']]);
            this.commentComponent.setInner(openComment);
        }
        this.editorContext.onFrameReady();
        this.editorContext.refresh();
    }
}
EditablePage.ɵfac = function EditablePage_Factory(t) { return new (t || EditablePage)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(EditorContextService), ɵngcc0.ɵɵdirectiveInject(PersonalizationServiceHelper)); };
EditablePage.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: EditablePage, selectors: [["editable-page"]], viewQuery: function EditablePage_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(CommentComponent, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.commentComponent = _t.first);
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 3, vars: 0, consts: [["child", ""]], template: function EditablePage_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "mgnl-comment");
        ɵngcc0.ɵɵelementContainer(1, null, 0);
    } }, dependencies: [CommentComponent], encapsulation: 2 });
EditablePage.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: EditorContextService },
    { type: PersonalizationServiceHelper }
];
EditablePage.propDecorators = {
    commentComponent: [{ type: ViewChild, args: [CommentComponent,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditablePage, [{
        type: Component,
        args: [{
                selector: 'editable-page',
                template: `
    <mgnl-comment></mgnl-comment>
    <ng-container #child></ng-container>
    `
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: EditorContextService }, { type: PersonalizationServiceHelper }]; }, { commentComponent: [{
            type: ViewChild,
            args: [CommentComponent]
        }] }); })();

class EditableComponent extends AbstractComponent {
    ngOnInit() {
        super.ngOnInit();
        this.templateAnnotationSubscription = this.editorContext.templateAnnotationsUpdated.subscribe(() => this.updateComment(this.content));
        this.templateDefinitionSubscription = this.editorContext.templateDefinitionsUpdated.subscribe(() => this.updateComment(this.content));
    }
    ngOnChanges(changes) {
        super.ngOnChanges(changes);
        if (changes.content) {
            this.updateComment(this.content);
        }
    }
    ngAfterViewInit() {
        this.updateComment(this.content);
    }
    ngOnDestroy() {
        var _a, _b;
        super.ngOnDestroy();
        (_a = this.templateAnnotationSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        (_b = this.templateDefinitionSubscription) === null || _b === void 0 ? void 0 : _b.unsubscribe();
    }
    updateComment(content) {
        this.editorContext.inEditorAsync().then((inEditor) => {
            if (!inEditor) {
                return;
            }
            if (!content) {
                LoggerService.warn('No content for this component');
                return;
            }
            if (this.editorContext.templateAnnotations) {
                const selectedVariants = this.personalizationService.selectedComponentVariants;
                const templateAnnotations = this.personalizationService.wrap(this.editorContext.templateAnnotations, selectedVariants);
                if (templateAnnotations && templateAnnotations[content['@path']]) {
                    this.openComment = templateAnnotations[content['@path']];
                    this.closeComment = '/cms:component';
                }
            }
            else if (this.editorContext.templateDefinitions && this.editorContext.templateDefinitions[content['mgnl:template']]) {
                // tslint:disable-next-line:max-line-length
                this.openComment = TemplateAnnotations.getComponentCommentString(content, this.editorContext.templateDefinitions[content['mgnl:template']]);
                this.closeComment = '/cms:component';
            }
            this.editorContext.refresh();
        });
    }
}
EditableComponent.ɵfac = /*@__PURE__*/ function () { let ɵEditableComponent_BaseFactory; return function EditableComponent_Factory(t) { return (ɵEditableComponent_BaseFactory || (ɵEditableComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(EditableComponent)))(t || EditableComponent); }; }();
EditableComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: EditableComponent, selectors: [["editable-component"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 4, vars: 2, consts: [[3, "ngIf"], ["child", ""], [3, "text"]], template: function EditableComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, EditableComponent_ng_template_0_Template, 1, 1, "ng-template", 0);
        ɵngcc0.ɵɵelementContainer(1, null, 1);
        ɵngcc0.ɵɵtemplate(3, EditableComponent_ng_template_3_Template, 1, 1, "ng-template", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.openComment);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.closeComment);
    } }, dependencies: [ɵngcc1.NgIf, CommentComponent], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditableComponent, [{
        type: Component,
        args: [{
                selector: 'editable-component',
                template: `
    <ng-template [ngIf]="openComment">
      <mgnl-comment [text]="openComment"></mgnl-comment>
    </ng-template>
    <ng-container #child></ng-container>
    <ng-template [ngIf]="closeComment">
      <mgnl-comment [text]="closeComment"></mgnl-comment>
    </ng-template>
    `
            }]
    }], null, null); })();

class MagnoliaModule {
}
MagnoliaModule.ɵfac = function MagnoliaModule_Factory(t) { return new (t || MagnoliaModule)(); };
MagnoliaModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: MagnoliaModule });
MagnoliaModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        WindowRefService,
        PersonalizationServiceHelper,
        EditorContextService,
        RendererContextService
    ], imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MagnoliaModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    DefaultFallbackComponent,
                    AbstractComponent,
                    EditablePage,
                    EditableComponent,
                    EditableArea,
                    CommentComponent
                ],
                providers: [
                    WindowRefService,
                    PersonalizationServiceHelper,
                    EditorContextService,
                    RendererContextService
                ],
                exports: [
                    DefaultFallbackComponent,
                    EditableArea,
                    EditableComponent,
                    EditablePage,
                    CommentComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MagnoliaModule, { declarations: function () { return [DefaultFallbackComponent, AbstractComponent, EditablePage, EditableComponent, EditableArea, CommentComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [DefaultFallbackComponent, EditableArea, EditableComponent, EditablePage, CommentComponent]; } }); })();

/*
 * Public API Surface of angular-editor
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CommentComponent, EditableArea, EditableComponent, EditablePage, EditorContextService, MagnoliaModule, PersonalizationServiceHelper, RendererContextService, DefaultFallbackComponent as ɵa, AbstractComponent as ɵb, WindowRefService as ɵc };

